// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Upload
 */
export interface Upload {
  /**
   *
   */
  id: string;
  /**
   *
   */
  branch: string;
  /**
   *
   */
  transactionId: string;
  /**
   *
   */
  address: string;
  /**
   *
   */
  urls?: Array<string>;
}

/**
 * Check if a given object implements the Upload interface.
 */
export function instanceOfUpload(value: object): value is Upload {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (!("branch" in value) || value["branch"] === undefined) return false;
  if (
    (!("transactionId" in (value as Record<string, any>)) &&
      !("transaction_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["transactionId"] === undefined &&
      (value as Record<string, any>)["transaction_id"] === undefined)
  )
    return false;
  if (!("address" in value) || value["address"] === undefined) return false;
  return true;
}

export function UploadFromJSON(json: any): Upload {
  return UploadFromJSONTyped(json, false);
}

export function UploadFromJSONTyped(json: any, ignoreDiscriminator: boolean): Upload {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    branch: json["branch"],
    transactionId: json["transaction_id"],
    address: json["address"],
    urls: json["urls"] == null ? undefined : json["urls"],
  };
}

export function UploadToJSON(json: any): Upload {
  return UploadToJSONTyped(json, false);
}

export function UploadToJSONTyped(
  value?: Upload | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    branch: value["branch"],
    transaction_id: value["transactionId"],
    address: value["address"],
    urls: value["urls"],
  };
}
